import type { RouteRecordRaw } from 'vue-router';

import MonitorForDevelopersRouteName from './MonitorForDevelopersRouteName';

const MonitorMessages = async () => import('@/features/monitor/developer/monitor-messages/MonitorMessages.vue');
const MonitorBuildInfo = async () => import('@/features/monitor/developer/monitor-build-info/MonitorBuildInfo.vue');
const MonitorClicker = async () => import('@/features/monitor/developer/monitor-clicker/MonitorClicker.vue');
const MonitorDebugSettings = async () =>
  import('@/features/monitor/developer/monitor-debug-settings/MonitorDebugSettings.vue');
const MonitorFacebookBeta = async () =>
  import('@/features/monitor/developer/monitor-facebook-beta/MonitorFacebookBeta.vue');
const MonitorSeed = async () => import('@/features/monitor/developer/monitor-seed/MonitorSeed.vue');

const MonitorPageForDevelopers = async () => import('@/pages/MonitorPageForDevelopers.vue');

export default function getMonitorForDevelopersRoutes(): RouteRecordRaw[] {
  return [
    {
      name: MonitorForDevelopersRouteName.MAIN,
      children: [
        {
          name: MonitorForDevelopersRouteName.BUILD_INFO,
          component: MonitorBuildInfo,
          meta: {
            title: 'Build info - Monitor for developers',
          },
          path: 'build-info',
        },
        {
          name: MonitorForDevelopersRouteName.DEBUG_SETTINGS,
          component: MonitorDebugSettings,
          meta: {
            title: 'Debug settings - Monitor for developers',
          },
          path: 'debug-settings',
        },
        {
          name: MonitorForDevelopersRouteName.SEED,
          component: MonitorSeed,
          meta: {
            title: 'Seed - Monitor for developers',
          },
          path: 'seed',
        },
        {
          name: MonitorForDevelopersRouteName.CLICKER,
          component: MonitorClicker,
          meta: {
            title: 'Clicker - Monitor for developers',
          },
          path: 'clicker',
        },
        {
          name: MonitorForDevelopersRouteName.MESSAGES,
          component: MonitorMessages,
          meta: {
            title: 'Messages - Monitor for developers',
          },
          path: 'messages',
        },
        {
          name: MonitorForDevelopersRouteName.FACEBOOK_BETA,
          component: MonitorFacebookBeta,
          meta: {
            title: 'Facebook Beta - Monitor for developers',
          },
          path: 'facebook-beta',
        },
      ],
      component: MonitorPageForDevelopers,
      meta: {
        title: 'Monitor for developers',
      },
      path: '/monitor/developer',
      redirect: {
        name: MonitorForDevelopersRouteName.BUILD_INFO,
      },
    },
  ];
}
